/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { useState } from "react";

import { Icon, IIconStyles, Link } from "office-ui-fabric-react";

import { ICopyButtonProps } from "./ICopyButtonProps";

/**
 * CopyButton component
 * @param {ICopyButtonProps} props the component props
 * @returns {void} rendered void.
 */
const CopyButton: React.FunctionComponent<ICopyButtonProps> = ({
  text,
  styles,
  showCopyText,
}): React.ReactElement => {
  const [isCopied, setIsCopied] = useState(false);

  /**
   * CopyToClipboard Function
   * @returns {void} rendered void.
   */
  const copyToClipboard = (): void => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  const copyIconStyles: IIconStyles = {
    root: {
      paddingRight: 5,
      verticalAlign: "bottom",
    },
  };

  return (
    <Link key={text} styles={styles} onClick={copyToClipboard}>
      <Icon iconName="copy" styles={copyIconStyles}></Icon>
      {showCopyText && (isCopied ? "Copied" : "Copy")}
    </Link>
  );
};

export default CopyButton;
